import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { FileStoreUtil } from "../../util/filestore.util";

@Component({
    selector: "s25-docusign-envelope-files",
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="envelope-files">
            @if (sentHref()) {
                <a [href]="sentHref()" target="_blank" rel="noopener noreferrer">Sent PDF</a>
            }
            @if (signedHref()) {
                <a [href]="signedHref()" target="_blank" rel="noopener noreferrer">Signed PDF</a>
            }
        </div>
    `,
    styles: `
        .envelope-files {
            display: flex;
            flex-wrap: wrap;
            gap: 0.75rem;
        }
    `,
})
export class S25DocusignEnvelopeFilesCellComponent {
    readonly fileKey = input("");
    readonly sentFileName = input("");
    readonly signedFileName = input("");
    readonly sentHref = computed(() => envelopePdfHref(this.fileKey(), this.sentFileName()));
    readonly signedHref = computed(() => envelopePdfHref(this.fileKey(), this.signedFileName()));
}

function envelopePdfHref(fileKey: string, fileName: string): string {
    if (!fileKey || !fileName) return "";
    return FileStoreUtil.buildDownloadUrl({
        fileName,
        objectType: -1,
        objectId: -1,
        fileKey,
    });
}
